module.exports = __webpack_public_path__ + "static/img/bgimage.02fbb3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgimage.png
// module id = s2Jd
// module chunks = 1